function getGreenPassStatus(plugins) {
    if(!plugins) return false;
    if(!plugins.greenpass) return false;
    if(!plugins.greenpass.enabled) return false;
    return true;
}

export {
    getGreenPassStatus,
}